export default __webpack_public_path__ + "static/media/cv_css.81d94986.png";